
export const defaultDeliveryInvoice = {
  company: {
    name: "Metagrad Logistics Pvt. Ltd.",
    address: "3rd Floor, Sector 62, Noida, Uttar Pradesh - 201309, India",
    gstin: "09AABCM1234F1Z5",
    phone: "+91 98765 43210",
    email: "accounts@metagradlogistics.com",
    logoText: "M"
  },

  invoice: {
    number: "INV-2024-0812",
    date: "12 Aug 2024",
    dueDate: "12 Aug 2024",
    terms: "Due on Receipt"
  },

  client: {
    name: "Apollo Medical Labs",
    address: "DLF Cyber City, Phase 2, Gurugram, Haryana - 122002",
    gstin: "06AAACM5678G1Z2"
  },

  items: [
    { id: 1, desc: "Medical Sample Delivery", qty: "1.00", unit: "Trip", rate: "1200.00", amount: "1200.00" },
    { id: 2, desc: "Distance Covered", qty: "180.00", unit: "KM", rate: "18.00", amount: "3240.00" },
    { id: 3, desc: "Driver Charges", qty: "1.00", unit: "Day", rate: "600.00", amount: "600.00" }
  ],

  summary: {
    subtotal: "5,040.00",
    gstRate: "18",
    gstAmount: "907.20",
    total: "5,947.20"
  }
};
